import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, use } from "react";

type LabelContextValue = {
    position: "left" | "right";
    type: "label" | "ribbon";
};

type LabelContextProviderProps = {
    position: "left" | "right";
    type: "label" | "ribbon";
    children: ReactNode;
};

export const LabelContext = createContext<LabelContextValue | undefined>(
    undefined
);
LabelContext.displayName = "LabelContext";

export const LabelContextProvider = ({
    position,
    type,
    children
}: LabelContextProviderProps) => {
    return (
        <LabelContext
            value={{
                type: type,
                position: position
            }}
        >
            {children}
        </LabelContext>
    );
};

export const useLabelContext = () => {
    const context = use<LabelContextValue | undefined>(LabelContext);

    if (!isDefined(context)) {
        throw new Error(`${LabelContext.displayName} is undefined.`);
    }

    return context;
};
